import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import {
  getPatientPreferredContactValue,
  normalizePatientInfo,
  normalizeTimezone,
} from 'utils';

const ContactInfo = ({ profile }) => {
  let patientProfile = {};
  if (profile) {
    patientProfile = normalizePatientInfo(profile);
  }

  return (
    <Table borderless border="0" cellSpacing="0" cellPadding="0">
      <thead>
        <tr>
          <th colSpan="2">
            <div className="pagination-container">
              <h5>Contact Info</h5>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td />
          <td>
            {(patientProfile.address ||
              patientProfile.city ||
              patientProfile.state ||
              patientProfile.zipPostalCode) && (
              <>
                <span className="subheader">Location:</span>
                <span>
                  {patientProfile.address} {patientProfile.city}{' '}
                  {patientProfile.state} {patientProfile.zipPostalCode}
                </span>
              </>
            )}

            {patientProfile.preferredContactMethod && (
              <>
                <span className="subheader">Preferred Contact Method:</span>
                <span style={{ display: 'inline' }}>
                  {patientProfile.preferredContactMethod}:{' '}
                </span>
                <span
                  className="text-transform-none"
                  style={{ display: 'inline' }}
                >
                  {getPatientPreferredContactValue(patientProfile)}
                </span>
              </>
            )}
            {patientProfile.phone && (
              <>
                <span className="subheader">Phone Number:</span>
                <span>{patientProfile.phone}</span>
              </>
            )}
            {patientProfile.email && (
              <>
                <span className="subheader">Email:</span>
                <span className="text-transform-none">
                  {patientProfile.email}
                </span>
              </>
            )}
            <>
              <span className="subheader">Auth0 account created:</span>
              <span className="nonCapitalized">
                {patientProfile.auth0Enabled === true ? 'Yes' : 'No'}
              </span>
            </>
            {patientProfile.emergencyContactNumber && (
              <>
                <span className="subheader">Emergency Contact:</span>
                <span>{patientProfile.emergencyContactNumber}</span>
              </>
            )}
            {patientProfile.emergencyContactFirstName && (
              <>
                <span className="subheader">Emergency Name:</span>
                <span>
                  {patientProfile.emergencyContactFirstName}{' '}
                  {patientProfile.emergencyContactLastName}{' '}
                </span>
              </>
            )}
            {patientProfile.homeNumber && (
              <>
                <span className="subheader">Secondary Phone Number:</span>
                <span>{patientProfile.homeNumber}</span>
              </>
            )}
            {patientProfile.emergencyContactRelationship && (
              <>
                <span className="subheader">Emergency Relationship Name:</span>
                <span>{patientProfile.emergencyContactRelationship}</span>
              </>
            )}
            {patientProfile.timezone && (
              <>
                <span className="subheader">Time Zone:</span>
                <span>
                  {normalizeTimezone(patientProfile.timezone) ?? 'NA'}
                </span>
              </>
            )}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

ContactInfo.propTypes = {
  profile: PropTypes.shape().isRequired,
};

export default ContactInfo;
